export default __webpack_public_path__ + "static/2-3-1-0-f3e73137e6d4d4164821899f8fbdcf1f.jpg";